module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-01autos-flotillas.c186bc93.jpg";